/* eslint-disable */
import Component from 'gia/Component'

export default class FilterDropdown extends Component {
  constructor(element) {
    super(element)
  }
  drop() {
    const button = $(this.element).children('.drop-trigger')
    const wrapper = $(this.element).find('.drop-wrapper')
    const advanceFilter = document.querySelector('.advance-filter')

    button.click(function(e) {
      if (advanceFilter) {
        const textwrapper = document.querySelector('.drop-trigger')
        if (advanceFilter.classList.contains('active')) {
          advanceFilter.classList.remove('active')
          textwrapper.textContent = 'Select filter...'
        } else {
          advanceFilter.classList.add('active')
          textwrapper.textContent = 'Click again to collapse'
        }
      }

      e.preventDefault()
      $(this).toggleClass('active')
      wrapper.fadeToggle(150)
    })
  }

  text() {
    const me = $(this.element)
    const textwrapper = me.find('.drop-trigger')
    let checked = me.find('.drop-wrapper input[checked]')

    function propObString(objects) {
      let choices = []
      objects.each(function() {
        let text = $(this)
          .siblings()
          .html()
        if (text) {
          choices.push(text)
        }
      })

      let newtext = choices.join(', ')
      if (newtext.length > 30) {
        newtext = newtext.substring(0, 30) + '...'
      } else if (newtext.length <= 0) {
        newtext = 'Select filters'
      }
      textwrapper.html(newtext)
    }

    propObString(checked)

    me.find('.drop-wrapper input').change(function() {
      const newchecked = me.find('.drop-wrapper input:checked')

      propObString(newchecked)
    })
  }

  mount() {
    this.drop()
    // this.text()
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/FilterDropdown.js